import { createSlice } from '@reduxjs/toolkit';

const initialState: boolean | null = null;

const dirtyAsignaturasStateSlice = createSlice({
	name: 'dirtyAsignaturasState',
	initialState,
	reducers: {
		setDirtyasignaturaState: (state, action) => {
			return action.payload;
		},
		resetDirtyasignaturaState: () => initialState
	}
});

export const { setDirtyasignaturaState, resetDirtyasignaturaState } = dirtyAsignaturasStateSlice.actions;
export default dirtyAsignaturasStateSlice.reducer;
